import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'aditya-pageloader',
  templateUrl: './pageloader.component.html',
  styleUrls: ['./pageloader.component.css']
})
export class PageloaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
